// extracted by mini-css-extract-plugin
export var circle = "_2g-2";
export var icon = "_2g-a";
export var iconHighlight = "_2g-0";
export var lg = "_2g-8";
export var md = "_2g-7";
export var outline = "_2g-4";
export var sm = "_2g-6";
export var square = "_2g-1";
export var xl = "_2g-9";
export var xs = "_2g-5";
export var xxs = "_2g-3";